import { Action } from '@ngrx/store'
import * as PathSettingsTypes from './ui-settings.types'

export class FetchUISettingsRequest implements Action {
  readonly type = PathSettingsTypes.FETCH_UI_SETTINGS_REQUEST
  constructor() {}
}

export class FetchUISettingsSuccess implements Action {
  readonly type = PathSettingsTypes.FETCH_UI_SETTINGS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchUISettingsFailure implements Action {
  readonly type = PathSettingsTypes.FETCH_UI_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateUISettingsRequest implements Action {
  readonly type = PathSettingsTypes.UPDATE_UI_SETTINGS_REQUEST
  constructor(public payload: any) {}
}

export class UpdateUISettingsSuccess implements Action {
  readonly type = PathSettingsTypes.UPDATE_UI_SETTINGS_SUCCESS
  constructor() {}
}

export class UpdateUISettingsFailure implements Action {
  readonly type = PathSettingsTypes.UPDATE_UI_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = PathSettingsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = PathSettingsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | FetchUISettingsSuccess
  | FetchUISettingsFailure
  | FetchUISettingsRequest
  | UpdateUISettingsRequest
  | UpdateUISettingsSuccess
  | UpdateUISettingsFailure
  | SetDefaultData
  | UpdateField
